import { LogoutAction } from './LogoutAction';
import { LogoutCompleteAction } from './LogoutCompleteAction';
import { UserIdentityUpdatedAction } from './UserIdentityUpdatedAction';
import { ChangePasswordAction } from './ChangePasswordAction';
import { QueryAvailableRolesAction } from './QueryAvailableRolesAction';
import { QueryAvailableRolesSuccessAction } from './QueryAvailableRolesSuccessAction';
import { QueryAvailableRolesByTypeAction } from './QueryAvailableRolesByTypeAction';
import { QueryAvailableRolesByTypeSuccessAction } from './QueryAvailableRolesByTypeSuccessAction';
import { QueryAvailablePermissionsAction } from './QueryAvailablePermissionsAction';
import { QueryAvailablePermissionsSuccessAction } from './QueryAvailablePermissionsSuccessAction';
import { AddPermissionToRoleAction } from './AddPermissionToRoleAction';
import { AddPermissionToRoleSuccessAction } from './AddPermissionToRoleSuccessAction';
import { RemovePermissionToRoleAction } from './RemovePermissionToRoleAction';
import { RemovePermissionToRoleSuccessAction } from './RemovePermissionToRoleSuccessAction';
import { AddRoleToRoleAction } from './AddRoleToRoleAction';
import { AddRoleToRoleSuccessAction } from './AddRoleToRoleSuccessAction';
import { RemoveRoleFromRoleAction } from './RemoveRoleFromRoleAction';
import { RemoveRoleFromRoleSuccessAction } from './RemoveRoleFromRoleSuccessAction';
import { GetCurrentUserPermissionsAction } from './GetCurrentUserPermissionsAction';
import { GetCurrentUserPermissionsSuccessAction } from './GetCurrentUserPermissionsSuccessAction';
import { GetCurrentUserSubmittingEntitiesAction } from './GetCurrentUserSubmittingEntitiesAction';
import { GetCurrentUserSubmittingEntitiesSuccessAction } from './GetCurrentUserSubmittingEntitiesSuccessAction';
import { GetCurrentUserProfileAction } from './GetCurrentUserProfileAction';
import { GetCurrentUserProfileSuccessAction } from './GetCurrentUserProfileSuccessAction';
import { GetSupportTicketInformationAction } from './GetSupportTicketInformationAction';
import { GetSupportTicketInformationSuccessAction } from './GetSupportTicketInformationSuccessAction';
import { ActivateDraftMessageToUsersAction } from './ActivateDraftMessageToUsersAction';
import { ActivateDraftMessageToUsersSuccessAction } from './ActivateDraftMessageToUsersSuccessAction';
import { SubmitSupportTicketAction } from './SubmitSupportTicketAction';
import { SubmitSupportTicketSuccessAction } from './SubmitSupportTicketSuccessAction';
import { ManageRoleErrorAction } from './ManageRoleErrorAction';

export type Actions = LogoutAction |
                      LogoutCompleteAction |
                      UserIdentityUpdatedAction |
                      ChangePasswordAction |
                      QueryAvailableRolesAction |
                      QueryAvailableRolesSuccessAction |
                      QueryAvailableRolesByTypeAction |
                      QueryAvailableRolesByTypeSuccessAction |
                      QueryAvailablePermissionsAction |
                      QueryAvailablePermissionsSuccessAction |
                      AddPermissionToRoleAction |
                      AddPermissionToRoleSuccessAction |
                      RemovePermissionToRoleAction |
                      RemovePermissionToRoleSuccessAction |
                      AddRoleToRoleAction |
                      AddRoleToRoleSuccessAction |
                      RemoveRoleFromRoleAction |
                      RemoveRoleFromRoleSuccessAction |
                      GetCurrentUserPermissionsAction |
                      GetCurrentUserPermissionsSuccessAction |
                      GetCurrentUserSubmittingEntitiesAction |
                      GetCurrentUserSubmittingEntitiesSuccessAction |
                      GetCurrentUserProfileAction |
                      GetCurrentUserProfileSuccessAction |
                      GetSupportTicketInformationAction |
                      GetSupportTicketInformationSuccessAction |
                      ActivateDraftMessageToUsersAction |
                      ActivateDraftMessageToUsersSuccessAction |
                      SubmitSupportTicketAction |
                      SubmitSupportTicketSuccessAction |
                      ManageRoleErrorAction;

export * from './LogoutAction';
export * from './LogoutCompleteAction';
export * from './UserIdentityUpdatedAction';
export * from './ChangePasswordAction';
export * from './QueryAvailableRolesAction';
export * from './QueryAvailableRolesSuccessAction';
export * from './QueryAvailableRolesByTypeAction';
export * from './QueryAvailableRolesByTypeSuccessAction';
export * from './QueryAvailablePermissionsAction';
export * from './QueryAvailablePermissionsSuccessAction';
export * from './AddPermissionToRoleAction';
export * from './AddPermissionToRoleSuccessAction';
export * from './RemovePermissionToRoleAction';
export * from './RemovePermissionToRoleSuccessAction';
export * from './AddRoleToRoleAction';
export * from './AddRoleToRoleSuccessAction';
export * from './RemoveRoleFromRoleAction';
export * from './RemoveRoleFromRoleSuccessAction';
export * from './GetCurrentUserPermissionsAction';
export * from './GetCurrentUserPermissionsSuccessAction';
export * from './GetCurrentUserSubmittingEntitiesAction';
export * from './GetCurrentUserSubmittingEntitiesSuccessAction';
export * from './GetCurrentUserProfileAction';
export * from './GetCurrentUserProfileSuccessAction';
export * from './GetSupportTicketInformationAction';
export * from './GetSupportTicketInformationSuccessAction';
export * from './ActivateDraftMessageToUsersAction';
export * from './ActivateDraftMessageToUsersSuccessAction';
export * from './SubmitSupportTicketAction';
export * from './SubmitSupportTicketSuccessAction';
export * from './ManageRoleErrorAction';



// WEBPACK FOOTER //
// ./src/app/security/store/actions/index.ts